// Libraries
var React = require('react');

// Components
var CallToAction = require('../../common/CallToAction/CallToAction');

// Styles
require('./ServerErrorModule.scss');

class ServerErrorModule extends React.Component {
	render() {		
		return (
			<div className="ServerError">
				<div className="ServerError__container">
					<h1 className="ServerError__title">Nooo... Missed It!</h1>
					<p className="ServerError__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
					<div className="ServerError__number">500</div>
					<CallToAction linkStyle="PRIMARY" url="/" newWindow={false} caption="Homepage"/>
				</div>
				<div className="ServerError__image"/>
			</div>
		)
	}
}

module.exports = ServerErrorModule;


// WEBPACK FOOTER //
// ./src/components/ServerError/ServerErrorModule.js